export default "__VITE_ASSET__BBBFkrbX__"